import { createContext, useContext, useEffect, useState } from "react";
import { http } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    http.get("/auth/me")
      .then((r) => { if (alive) setUser(r.data); })
      .catch(() => { if (alive) setUser(false); });
    return () => { alive = false; };
  }, []);

  const logout = async () => {
    await http.post("/auth/logout").catch(() => null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
